export enum MyBoosterActionTypes {
  ACTIVATE_BOOSTER = '@my-boosters/ACTIVATE_BOOSTER',
  GET_TOKEN_ACTIVE_BOOSTERS = '@my-boosters/GET_TOKEN_ACTIVE_BOOSTERS',
  GET_LEVEL_ACTIVE_BOOSTERS = '@my-boosters/GET_LEVEL_ACTIVE_BOOSTERS',
  GET_MISSION_ACTIVE_BOOSTERS = '@my-boosters/GET_MISSION_ACTIVE_BOOSTERS',
  GET_MY_BOOSTERS = '@my-boosters/GET_MY_BOOSTERS',
}
